import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class InvoiceService {
    /**
     * Gets an invoice
     * Gets an invoice by specified ID provided in path as variable.
     * @param id
     * @returns InvoiceDTO Gets an invoice
     * @throws ApiError
     */
    static getInvoice(id) {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/invoice/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                405: `Method Not Allowed`,
                415: `Unsupported Media Type`,
                422: `Unprocessable Entity`,
            },
        });
    }
    /**
     * Gets an invoice
     * Gets an invoice by specified ID provided in path as variable.
     * @param id
     * @returns InvoiceDTO Gets an invoice
     * @throws ApiError
     */
    static getInvoice1(id) {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/invoice/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                405: `Method Not Allowed`,
                415: `Unsupported Media Type`,
                422: `Unprocessable Entity`,
            },
        });
    }
    /**
     * Updates an invoice
     * Updates an invoice via specified ID in path as variable, and parts of the entity to be updated, provided in response body.
     * @param id
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    static replaceById(id, requestBody) {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/invoice/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                405: `Method Not Allowed`,
                415: `Unsupported Media Type`,
                422: `Unprocessable Entity`,
            },
        });
    }
    /**
     * Updates an invoice
     * Updates an invoice via specified ID in path as variable, and parts of the entity to be updated, provided in response body.
     * @param id
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    static replaceById1(id, requestBody) {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/invoice/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                405: `Method Not Allowed`,
                415: `Unsupported Media Type`,
                422: `Unprocessable Entity`,
            },
        });
    }
    /**
     * Deletes an invoice
     * Deletes an invoice via specified ID provided in path as variable.
     * @param id
     * @returns void
     * @throws ApiError
     */
    static removeById(id) {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/invoice/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                405: `Method Not Allowed`,
                415: `Unsupported Media Type`,
                422: `Unprocessable Entity`,
            },
        });
    }
    /**
     * Deletes an invoice
     * Deletes an invoice via specified ID provided in path as variable.
     * @param id
     * @returns void
     * @throws ApiError
     */
    static removeById1(id) {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/invoice/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                405: `Method Not Allowed`,
                415: `Unsupported Media Type`,
                422: `Unprocessable Entity`,
            },
        });
    }
    /**
     * Gets all invoices
     * Gets all invoices.
     * @returns InvoiceDTO Gets all invoices
     * @throws ApiError
     */
    static getAllInvoices() {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/invoice',
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                405: `Method Not Allowed`,
                415: `Unsupported Media Type`,
                422: `Unprocessable Entity`,
            },
        });
    }
    /**
     * Gets all invoices
     * Gets all invoices.
     * @returns InvoiceDTO Gets all invoices
     * @throws ApiError
     */
    static getAllInvoices1() {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/invoice',
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                405: `Method Not Allowed`,
                415: `Unsupported Media Type`,
                422: `Unprocessable Entity`,
            },
        });
    }
    /**
     * Create new invoice
     * Create a new invoice by specifying required, and/or optional fields in request body.
     * @param requestBody
     * @returns InvoiceDTO creates a new invoice
     * @throws ApiError
     */
    static createInvoice(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/invoice',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                405: `Method Not Allowed`,
                415: `Unsupported Media Type`,
                422: `Unprocessable Entity`,
            },
        });
    }
    /**
     * Create new invoice
     * Create a new invoice by specifying required, and/or optional fields in request body.
     * @param requestBody
     * @returns InvoiceDTO creates a new invoice
     * @throws ApiError
     */
    static createInvoice1(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/invoice',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                405: `Method Not Allowed`,
                415: `Unsupported Media Type`,
                422: `Unprocessable Entity`,
            },
        });
    }
}
